<template>
  <div class="gift-detail">
    <div
      class="card-info shadow"
      style="font-family: PingFangSC-Medium"
    >
      <div class="content-flex">
        <div class="medium">手机号码：</div>
        {{ item.rechargePhone }}
      </div>
      <div class="content-flex">
        <div class="medium">归属地区：</div>
        {{ item.phoneAttribution }}
      </div>
      <div class="content-flex">
        <div class="medium">充值面额：</div>
        {{ item.productSkuName }}元
      </div>
      <div
        class="content-flex"
        :class="{
          red: [CarLifeOrderStatus.cancel].includes(item.rechargeStatus) && isRefund,
          blue: [CarLifeOrderStatus.unpaid].includes(item.rechargeStatus),
        }"
      >
        <div class="medium">充值状态：</div>
        {{ item.rechargeStatus | statusFilter }}
      </div>
    </div>
    <div
      class="card-info"
      :class="{
        shadow: [CarLifeOrderStatus.cancel, CarLifeOrderStatus.unpaid].includes(
          item.rechargeStatus
        ),
      }"
    >
      <div class="content-flex">
        <div class="left">订单编号</div>
        {{ item.orderNo }}
      </div>
      <div class="content-flex">
        <div class="left">下单时间</div>
        {{ item.createTime }}
      </div>
      <template v-if="showPrice">
        <div class="content-flex">
          <div class="left">商品总额</div>
          ¥{{ item.productSkuPrice }}
        </div>
        <div class="content-flex">
          <div class="left">权益优惠</div>
          ¥{{ item.rightDiscount }}
        </div>
      </template>
      <div
        class="content-flex"
        v-if="[CarLifeOrderStatus.cancel].includes(item.rechargeStatus)"
      >
        <div class="left">{{ isRefund ? "实际支付" : "需支付" }}</div>
        ¥{{ item.customerPay }}
      </div>
      <div
        class="content-flex"
        v-if="![CarLifeOrderStatus.cancel].includes(item.rechargeStatus)"
      >
        <div class="left">实际支付</div>
        ¥{{ item.customerPay }}
      </div>
    </div>
    <div
      class="card-info"
      v-if="
        [CarLifeOrderStatus.cancel, CarLifeOrderStatus.unpaid].includes(
          item.rechargeStatus
        )
      "
    >
      <div
        class="content-flex"
        v-if="CarLifeOrderStatus.cancel === item.rechargeStatus"
        :class="{
          red: [CarLifeOrderStatus.cancel].includes(item.rechargeStatus),
        }"
      >
        <div class="left">退款总额</div>
        ¥{{ item.refundTotalAmount || "0.00" }}
      </div>
      <div
        v-if="CarLifeOrderStatus.cancel === item.rechargeStatus"
        class="content-flex"
      >
        <div class="left">权益金额</div>
        ¥{{ item.rightDiscount }}
      </div>
      <div
        v-if="[CarLifeOrderStatus.cancel].includes(item.rechargeStatus) && isRefund"
      >
        <div class="content-flex">
          <div class="left">在线支付</div>
          ¥{{ item.customerPay }}
        </div>
        <div class="refund-tips">支付金额将在1-3个工作日内退回原支付账户</div>
      </div>
    </div>

    <div
      class="button-wrapper"
      v-if="[CarLifeOrderStatus.unpaid].includes(item.rechargeStatus)"
    >
      <van-button
        class="submit"
        type="info"
        @click="submitClick"
      >立即支付</van-button>
      <div
        class="cancel"
        @click="cancelClick"
      >取消订单</div>
    </div>
    <cancel-order
      ref="cancelOrder"
      @cancelClick="sureCancel"
    />
  </div>
</template>

<script>
import CancelOrder from '@/components/cancel-order.vue';
import Pay from '@/common/weixin.js';
import Utils from '@/common/util.js';
import { carLifePayPre, carLifeOrderDetail } from '@/common/api.js';
import { CarLifeOrderStatus } from '@/common/constant.js';
import dayjs from 'dayjs';
import { debounce } from 'lodash';

export default {
  name: 'PhoneChargeDetail',
  components: {
    CancelOrder
  },
  // props: {
  //   // 订单id, 通过 $route.params 传入
  //   orderNo: [String, Number],
  // },
  filters: {
    statusFilter(value) {
      if (!value) {
        return '';
      }
      const statusMap = {
        [CarLifeOrderStatus.unpaid]: '待支付',
        [CarLifeOrderStatus.success]: '充值成功',
        [CarLifeOrderStatus.cancel]: '已取消',
        [CarLifeOrderStatus.processing]: '充值中'
      };
      return statusMap[value];
    }
  },
  data() {
    return {
      CarLifeOrderStatus,
      item: {},
      heckPayCount: 3, // 是否支付最多检查次数
      checkPayTime: 3000 // 每次检查是否支付中间的间隔
    };
  },

  computed: {
    isRefund() {
      return this.item.refundAmount > 0;
    },
    // 是否展示商品售价和权益优惠
    showPrice() {
      return Number(this.item.customerPay) !== 0;
    }
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.orderNo) {
        const arr = this.$route.query.orderNo;
        if (Array.isArray(arr)) {
          this.orderNo = arr[arr.length - 1];
        } else {
          this.orderNo = this.$route.query.orderNo;
        }
      }

      // 支付回调过来的
      if (this.$route.query.isCallBack) {
        const newHref = window.location.href.replace(/&isCallBack=\d/, '');
        location.replace(newHref);
        this.showConfirmDialog();
      }
      this.loadDeatil();
    },
    async loadDeatil() {
      try {
        const res = await carLifeOrderDetail({ orderNo: this.orderNo });
        console.log('详情数据');
        console.log(res);
        if (res) {
          this.item = res;
        }
      } catch (error) {
        console.log('后台数据有误');
      }
    },
    cancelClick() {
      console.log(this.item.orderNo);
      this.$refs.cancelOrder.init({ orderId: this.item.orderNo });
    },
    dateTransform(dateTimestamp) {
      if (dateTimestamp) {
        return Utils.formatTimestamp(dateTimestamp);
      }
      return '';
    },
    // 立即支付的
    submitClick: debounce(
      async function() {
        try {
          const envMap = ['1', '1', '4'];
          // 调起预支付接口成功后
          const prepayRs = await carLifePayPre({
            payType: envMap[this.$browserEnv], // 支付环境
            orderNo: this.orderNo
          });
          this.prePayHandle(prepayRs);
        } catch (error) {
          console.log(error);
        }
      },
      3000,
      { leading: true, trailing: false }
    ),
    async showConfirmDialog() {
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      this.checkPay();
    },
    async checkPay() {
      try {
        const res = await carLifeOrderDetail({
          orderNo: this.orderNo
        });
        this.$toast.clear();
        // 待支付的，在订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.item = res;
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.init);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },
    prePaySuccess() {
      this.$router.push({
        name: 'resultPage',
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '00'
        }
      });
    },
    sureCancel() {
      this.loadDeatil();
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD hh:mm:ss');
    }
  }
};
</script>

<style lang="scss" scoped>
.gift-detail {
  background: white;
  width: 7.5rem;
  height: 100vh;
  overflow-y: auto;
  font-size: 0.32rem;
}

.card-info {
  margin: 0.4rem;
  padding-bottom: 0.4rem;
  font-size: 0.32rem;

  .content-flex {
    width: 100%;
    display: flex;
    flex-direction: row;
    word-break: break-all;
    margin-top: 0.24rem;
    color: #383838;

    .left {
      color: #787878;
      min-width: 1.62rem;
    }

    .medium {
      font-family: PingFangSC-Medium;
      color: #383838;
      min-width: 1.62rem;
    }

    &.red {
      color: #ff4242;
      font-family: PingFangSC-Medium;
    }
    &.blue {
      color: #3399ff;
    }
  }

  .refund-tips {
    font-size: 0.28rem;
    color: #ea3f26;
    margin-top: 0.24rem;
  }
}

.shadow {
  box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);
}
.card-camilo {
  margin: 0.4rem;
  padding-bottom: 0.4rem;
  color: #383838;
  font-size: 0.24rem;

  .header-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.32rem;
    align-items: center;
    padding-bottom: 0.08rem;

    .email {
      color: #3399ff;
      font-size: 0.24rem;
    }
  }

  .camilo-wrapper {
    margin-top: 0.16rem;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .copy {
    color: #4d7399;
    font-size: 0.24rem;
    margin-left: 0.4rem;
  }
}

.button-wrapper {
  margin-top: 0.32rem;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  .submit {
    width: 6.7rem;
    height: 00.96rem;
    font-size: 0.32rem;
    border-radius: 0.16rem;
  }
  .cancel {
    margin: 0.48rem;
    color: #4d7399;
  }
}
</style>
